<template>
  <div>
    <div v-if="list.length > 0">
      <div
        class="bg-body rounded-3 shadow-200 mb-3"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="flex-between-center p-3">
          <!-- 2026-08-20: 고객명 클릭 → /user/:idx 이동을 제거했다.
               그 화면(views/cs/UserDetail.vue)은 API 호출이 하나도 없는 **완전 목업**이라
               누구를 눌러도 "홍길동 / 010-0000-0000 / 캐쉬 0원 / 상담이력 임시" 가 떴다.
               담당자가 그 '캐쉬 0원'을 실제 잔액으로 보고 결제 불가로 오판할 수 있어 진입을 막는다.
               실제 고객정보 화면이 만들어지면 그때 다시 연결할 것. -->
          <div class="flex-start-center">
            <div class="ratio ratio-1x1 w-px-30 me-2 flex-shrink-0" >
              <img
                :src="CheckUserImage(item.profile_image)"
                alt="avatar"
                class="avatar rounded-circle w-100 object-fit-cover"
              />
            </div>
            <div class="d-flex flex-column align-items-start">
              <span class="fw-bold">{{ item.user_name }}</span>
              <!-- index === 0 임시 코드  -->
              <!-- <p class="fs-px-11 text-danger" v-if="index===0"><i class="far fa-exclamation-circle me-1"></i>사용 중지 고객입니다.</p> -->
            </div>
          </div>
          <div class="d-flex flex-column align-items-end">
            <a
              :href="`tel:${item.user_phone}`"
              class="small flex-start-center rounded-pill bg-gray-relative-200 py-1 px-2 flex-shrink-0"
            >
              <i
                class="fas fa-mobile-alt text-gray-relative-600 ms-1 me-2 small"
              ></i>
              <span class="me-1 small">{{ item.user_phone }}</span>
              <i
                class="fas fa-chevron-right small ms-1 text-gray-relative-500"
              ></i>
            </a>
            <span v-if="pay_request" class="mt-2 small flex-start-center rounded-pill bg-main text-white py-1 px-2 flex-shrink-0" @click="pp=true; additional_price=0;">

              <span class="me-1 small">추가 결제요청</span>
              
            </span>
          </div>
        </div>
        <hr class="cutting_line border-gray-relative-600 h-0 my-0 mx-3" />
        <div class="p-3">
          <div class="flex-between-center">
            <div class="flex-start-center small mb-2">
              <i
                class="fa fa-map-marker text-gray-relative-400 me-2 w-px-18"
              ></i>
              <span>{{ item.location_name }}</span>
            </div>
            <p class="small text-end mb-2 text-muted">
              {{ addDay(item.update_time) }}
            </p>
          </div>
          <div class="flex-start-center small mb-2" v-if="item.type != 'D'">
            <i class="fal fa-calendar text-gray-relative-400 me-2 w-px-18"></i>
            <span
              >{{ item.date }} ({{ item.start_time }} ~
              {{ item.end_time }})</span
            >
          </div>

          <div class="flex-start-center small" v-if="item.confirm_time != ''">
            <i class="fal fa-clock text-gray-relative-400 me-2 w-px-18"></i>
            <span>{{ addDay(item.date) }} ({{ item.confirm_time }})</span>
          </div>

          <div class="mt-3 small" v-if="paymentSummary(item).total !== null">
            <div class="d-flex justify-content-between mb-1">
              <span class="text-gray-relative-600">총 결제 요청 금액</span>
              <b>{{ CheckPrice(paymentSummary(item).total) }}원</b>
            </div>
            <div
              class="d-flex justify-content-between mb-1"
              v-for="fee in paymentSummary(item).items"
              :key="`${item.code}-${fee.key}`"
            >
              <span class="text-gray-relative-600">{{ fee.name }}</span>
              <span>{{ fee.price === null ? '-' : `${CheckPrice(fee.price)}원` }}</span>
            </div>
          </div>

          <div class="mt-3">
            <div class="d-flex justify-content-between">
              <div>
                <div
                  class="small mb-2 mt-2 badge rounded-pill"
                  :class="CheckStatusColor(item.status)"
                >
                  <i
                    class="fas me-2 w-px-18 small"
                    :class="{
                      'fa-spinner': item.status == 'H',
                      'fa-check': item.status == 'Y',
                      'fa-times': item.status == 'C',
                      'fa-trash': item.status == 'CP',
                      'fa-calendar': item.status == 'P',
                    }"
                  ></i>
                  <span>{{ CheckStatus(item.status) }}</span>
                </div>
                <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_success_light"
                  v-if="item.type == 'D'"
                >
                  <i class="fas me-2 w-px-18 small fa-check"></i>
                  <span>직접예약</span>
                </div>
                <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_warning_light"
                  v-if="item.edited == 'Y'"
                >
                  <i class="fas me-2 w-px-18 small fa-pen"></i>
                  <span>수정됨</span>
                </div>
                <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_warning_light"
                  v-if="item.is_direct_payment_pending"
                >
                  <i class="fas me-2 w-px-18 small fa-credit-card"></i>
                  <span>회원 직접결제 진행중</span>
                </div>
              </div>
              <div>
                <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_warning_light"
                  role="button"
                  @click="GotoReservationDetail(item.code)"
                >
                  <i class="fas me-2 w-px-18 small fa-search"></i>
                  <span>상세정보</span>
                </div>
                <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_success_light"
                  v-if="item.status == 'Y'"
                  role="button"
                  @click="GotoPaymentReceipt(item.code)"
                >
                  <i class="fal me-2 w-px-18 small fa-receipt"></i>
                  <span>상품권 매출 전표</span>
                </div>
                <!-- <div
                  class="small mb-2 mt-2 ms-2 badge rounded-pill badge_danger_light"
                  v-if="item.status == 'CP'"
                  @click="ConfirmCancel(item.code)"
                >
                  <i class="fas me-2 w-px-18 small fa-info"></i>
                  <span>취소승인</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="border-top p-3 border-gray-relative-200"
          v-if="item.status == 'H' && item.is_direct_payment_pending"
        >
          <p class="small text-muted mb-0 text-center">
            회원이 직접 결제를 진행 중인 예약입니다. 결제가 완료되거나 취소될 때까지 기다려주세요.
          </p>
        </div>
        <div
          class="border-top p-3 border-gray-relative-200"
          v-else-if="item.status == 'H'"
        >
          <ul class="d-flex">
            <li
              class="rounded-3 p-2 text-center bg-gray-relative-200 flex-grow-1 me-1"
              @click="Refuse(item)"
            >
              {{ CheckStatus('C') }}
            </li>
            <li
              class="rounded-3 p-2 text-center bg-main flex-grow-1 text-white"
              @click="Approval(item)"
              v-if="item.type != 'D'"
            >
              {{ CheckStatus('P') }}
            </li>
            <li
              class="rounded-3 p-2 text-center bg-main flex-grow-1 text-white"
              @click="ApprovalDirect(item)"
              v-if="item.type == 'D'"
            >
              {{ CheckStatus('P') }}
            </li>
          </ul>
        </div>
        <div
          class="border-top p-3 border-gray-relative-200"
          v-if="item.status == 'CP'"
        >
          <div class="d-flex">
            <li
              class="rounded-3 p-2 text-center bg-gray-relative-200 flex-grow-1 me-1"
              @click="RefusePayment(item)"
            >
              취소거절
            </li>
            <li
              class="rounded-3 p-2 text-center bg-main flex-grow-1 text-white"
              @click="GotoPaymentReceipt(item.code)"
              v-if="item.type == 'D'"
            >
              취소승인
            </li>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty_data">
      <p class="text-center py-5">예약이 없습니다.</p>
    </div>
    <div class="basic_pp bottom_up" v-show="pp"  :class="{'off':off}">
        <div class="dimm bg-body-i bg-opacity-50" @click="pp_off()"></div>
        <div class="content bg-body text-center" ref="basic_pp_body">
            
            <div class="flex-between-center mb-2 ">
              <b class="fs-px-14">추가결제를 요청합니다.</b>
                <button class="btn border-0" @click="pp_off()"><i class="fal fa-times ms-auto text-gray-relative-500"></i></button>
            </div>
            <input type="number" class="form-control" v-model="additional_price" placeholder="0">
            <button class="mt-3 btn btn-main w-100 text-white shadow-sm" @click="RequestAdditionalPayment()">요청</button>
        </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/mixins';
const CryptoJS = require('crypto-js');

export default {
  mixins: [format],
  data(){
    return{
      additional_price:0,
      pp: false,
			off: false,
      timeout_id: null,
    }
  },
  props: {
    list: {
      type: Array,
      default: [],
    },
    pay_request:{
      type:Boolean,
      deafult: false,
    }
  },
  methods: {
    // 2026-08-20: 이 버튼은 원래 `@click="pp_off"` 였다 — **팝업만 닫히고 서버로는 아무것도 안 갔다.**
    // 담당자는 금액까지 입력하고 눌렀으니 요청이 접수된 줄 알았지만 실제로는 아무 일도 없었다.
    // 서버에 대응 기능이 없다(`/shop/reservation/PaymentAdd` 는 item_list 기반의 다른 기능이라
    // 금액만 받는 이 화면과 맞지 않는다). 기능이 생기기 전까지는 사실대로 알린다.
    RequestAdditionalPayment() {
      this.$alert('추가 결제요청은 아직 제공되지 않는 기능입니다.<br>고객에게 별도로 결제요청을 보내주세요.');
      this.pp_off();
    },
    CheckPrice(price) {
      const amount = Number(price);
      if (!Number.isFinite(amount)) {
        return '-';
      }

      return amount.toLocaleString();
    },
    parseAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount : null;
    },
    getPaymentItems(item) {
      const rawItems = Array.isArray(item.item_list)
        ? item.item_list
        : Array.isArray(item.payment_item_list)
          ? item.payment_item_list
          : [];

      const items = rawItems
        .map((fee, index) => {
          const amount = this.parseAmount(fee.price);
          const code = String(fee.code || '').toUpperCase();
          const nameMap = {
            GREEN: '그린피',
            CART: '카트비',
            ETC: '기타',
          };

          return {
            key: fee.code || fee.name || index,
            name: fee.name || nameMap[code] || '기타',
            price: amount,
          };
        })
        .filter((fee) => fee.price !== null);

      if (items.length > 0) {
        return items;
      }

      if (item.cart === 'Y') {
        return [
          { key: 'green', name: '그린피', price: null },
          { key: 'cart', name: '카트비', price: null },
        ];
      }

      return [{ key: 'green', name: '그린피', price: this.parseAmount(item.price) }];
    },
    paymentSummary(item) {
      const items = this.getPaymentItems(item);
      const directTotal = this.parseAmount(item.price);
      const itemTotal = items.reduce((sum, fee) => {
        return fee.price === null ? sum : sum + fee.price;
      }, 0);

      return {
        total: directTotal !== null ? directTotal : itemTotal > 0 ? itemTotal : null,
        items,
      };
    },
    pp_off(){
      this.off = true;

      if (this.timeout_id) {
          clearTimeout(this.timeout_id);
      }

      this.timeout_id = setTimeout(() => {
          this.pp = false;
          this.off = false;
          if( this.$refs.basic_pp_body ){
              this.$refs.basic_pp_body.scrollTop = 0;}
          this.timeout_id = null;
      }, 200);
    },

    GotoReservationDetail(code) {
      this.$router.push({ path: `/reservation/detail/${code}` });
    },
    GotoPaymentReceipt(code) {
      this.$router.push({ path: `/payment/receipt/${code}` });
    },
    CheckStatusColor(status) {
      if (status == 'H') {
        return 'badge_warning_light';
      } else if (status == 'Y') {
        return 'badge_success_light';
      } else if (status == 'C') {
        return 'badge_danger_light';
      } else if (status == 'P') {
        return 'badge_warning_light';
      } else if (status == 'CP') {
        return 'badge_danger_light';
      }
    },
    CheckStatus(status) {
      if (status == 'Y') {
        return '예약완료';
      } else if (status == 'H') {
        return '결제대기';
      } else if (status == 'P') {
        return '결제요청';
      } else if (status == 'C') {
        return '예약취소';
      } else if (status == 'CP') {
        return '취소요청';
      }
    },
    CheckUserImage(src) {
      if (src == '') {
        return '/assets/image/profile_default.svg';
      } else {
        return src;
      }
    },
    Refuse(item) {
      this.$confirm(
        `매장명 : ${item.location_name}<br>예약일 : ${item.date}<br>예약을 거절하시겠습니까?`
      ).then((result) => {
        if (result.isOk) {
          this.CancelReservation(item);
        }
      });
    },

    Approval(item) {
      this.$confirm(
        `매장명 : ${item.location_name}<br>'${item.date} (${item.start_time} ~ ${item.end_time})'<br>결제 요청을 하시겠습니까?`
      ).then((result) => {
        if (result.isOk) {
          this.$router.push(`/reservation/payment/${item.code}`);
        }
      });
    },
    ApprovalDirect(item) {
      this.$confirm(
        `매장명 : ${item.location_name}<br>'${item.date} (${item.confirm_time})'<br>결제 요청을 하시겠습니까?`
      ).then((result) => {
        if (result.isOk) {
          this.$router.push(`/reservation/payment/${item.code}`);
        }
      });
    },

    TimeFormmat(time_str) {
      if (time_str == 'A') {
        return '오전';
      } else {
        return '오후';
      }
    },
    DayFormat(day_str) {
      const days = ['일', '월', '화', '수', '목', '금', '토'];
      const date = new Date(day_str);
      return days[date.getDay()];
    },
    CancelReservation(item) {
      const code = item.code;
      const body = { code };
      const req = CryptoJS.AES.encrypt(
        JSON.stringify(body),
        process.env.VUE_APP_SECRET_TOKEN
      ).toString();
      this.loading = true;
      this.$http
        .post('/shop/reservation/CancelReservation', { req })
        .then((res) => {
          if (res.status == 200) {
            this.loading = false;
            if (res.data.code == '200') {
              this.$alert('예약을 취소하였습니다.').then(() => {
                this.$router.go();
              });
            } else if (res.data.message) {
              this.$alert(res.data.message);
            }
          }
        });
    },
    CancelReservationReject(item) {
      const code = item.code;
      const body = { code };
      const req = CryptoJS.AES.encrypt(
        JSON.stringify(body),
        process.env.VUE_APP_SECRET_TOKEN
      ).toString();
      this.$http
        .post('/shop/reservation/CancelReservationReject', { req })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.code == '200') {
              this.$alert('취소 요청이 거절되었습니다.').then(() => {
                this.$router.go();
              });
            }
          }
        });
    },
    RefusePayment(item) {
      this.$confirm(
        `매장명 : ${item.location_name}<br>예약일 : ${item.date}<br>취소 요청을 거절하시겠습니까?`
      ).then((result) => {
        if (result.isOk) {
          this.CancelReservationReject(item);
        }
      });
    },
  },
};
</script>

<style></style>
